import ShareReportUserSelectorButton from '../controls/ShareReportUserSelectorButton'
import {AccessRights, OvertimeTrackingLevel, ReportChartType, ReportType} from 'constants'
import {arrayToSet} from '../atUtils'
import $ from 'jquery'
import makeRpcCall from '../util/jquery_rpc'
import {toast} from '../toasts/utils'
import messageResource from '../messageResource'
import UserNameFormat from '../util/UserNameFormat'

export default class ReportConfig {

    constructor(node, id, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, configType, manageableUsersIds, loggedInUserId) {
        this.activeClass = 'active'
        this.active = false

        this.node = node
        this.id = id
        this.configFormat = configFormat
        this.configType = configType

        addListener(this.node, 'mousedown', makeHandler(this._mouseDown, this))
        addListener(this.node, 'mouseup', makeHandler(this._mouseUp, this))

        this.createShareButton(configType, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, manageableUsersIds, loggedInUserId)
    }

    createShareButton(configType, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, manageableUsersIds, loggedInUserId) {
        this.shareButton = new ShareReportUserSelectorButton({
            selectorId: 'shareConfig' + this.id,
            userSelection: {
                allUsers: true,
                selectedUsers: [],
                selectedGroups: [],
                showDisabled: false,
                groupType: null,
                includeUserTeamOnly: false
            },
            changeCallback: () => this._shareSavedConfig(),
            withApplyButton: true,
            needAdditionalCheckbox: false,
            includeUsersWithoutDataDefaultValue: true,
        })
        let selectorUsers = this._filterSharedSelectorUsers(users, configType)
        selectorUsers = this._convertSharedSelectorUsers(selectorUsers)
        const loggedInUserNotInTeam = !!manageableUsersIds
                                      && manageableUsersIds.indexOf(parseInt(loggedInUserId)) === -1
                                      && users.some(u => u.id === parseInt(loggedInUserId))
        this.shareButton.updateSelector(
            selectorUsers,
            userGroupsEnabled,
            userGroups,
            timeZoneGroupsEnabled,
            timeZoneGroups,
            manageableUsersIds,
            false,
            loggedInUserNotInTeam
        )

        this.shareButton.updateButton()
    }

    isActive() {
        return this.active
    }

    _filterSharedSelectorUsers(users, configType) {
        return users.filter(u => {
            if (!u.active) return false

            const accessRightsMap = arrayToSet(u.accessRights)

            const moneyReportTypes = arrayToSet([
                ReportType.BILLING_SUMMARY,
                ReportType.INVOICING,
                ReportType.COST_OF_WORK,
                ReportType.PROFIT_LOSS,
                ReportType.COST_OF_WORK,
                ReportChartType.BILLABLE_AMOUNTS
            ])

            if (moneyReportTypes[configType]) {
                return !!accessRightsMap[AccessRights.GENERATE_MONEY_REPORTS]
            }

            const taskReportTypes = arrayToSet([
                ReportType.STAFF_PERFORMANCE,
                ReportType.TIME_TRACK_IN_DETAIL,
                ReportType.ESTIMATED_VS_ACTUAL,
                ReportChartType.TOTAL_WORKING_HOURS,
                ReportChartType.APPROVED_WORKING_HOURS
            ])

            if (taskReportTypes[configType]) {
                return !!accessRightsMap[AccessRights.SUBMIT_TIME_TRACK] ||
                       !!accessRightsMap[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] ||
                       !!accessRightsMap[AccessRights.EDIT_HIERARCHY] ||
                       !!accessRightsMap[AccessRights.GENERATE_MONEY_REPORTS] ||
                       !!accessRightsMap[AccessRights.MANAGE_USERS]
            }

            // Without PTO_BALANCE, SICK_DAYS_BALANCE and OVERTIME_HOURS, they are special, described separately
            const userReportTypes = arrayToSet([
                ReportType.OVERTIME,
                ReportType.LEAVE_TIME,
                ReportChartType.LEAVE_HOURS
            ])

            if (userReportTypes[configType]) {
                return !!accessRightsMap[AccessRights.SUBMIT_TIME_TRACK] ||
                       !!accessRightsMap[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] ||
                       !!accessRightsMap[AccessRights.GENERATE_MONEY_REPORTS] ||
                       !!accessRightsMap[AccessRights.MANAGE_USERS]
            }

            if (configType === ReportChartType.PTO_BALANCE ||
                configType === ReportChartType.SICK_DAYS_BALANCE ||
                configType === ReportChartType.OVERTIME_HOURS
            ) {
                if (!!accessRightsMap[AccessRights.MANAGE_USERS] ||
                    !!accessRightsMap[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] ||
                    !!accessRightsMap[AccessRights.MANAGE_PTO_AND_SICK]
                ) return true

                if (!!accessRightsMap[AccessRights.SUBMIT_TIME_TRACK]) {
                    if (configType === ReportChartType.PTO_BALANCE) {
                        return u.isPTO
                    }
                    if (configType === ReportChartType.SICK_DAYS_BALANCE) {
                        return u.isSick
                    }
                    if (configType === ReportChartType.OVERTIME_HOURS) {
                        return u.isOvertimeTracking &&
                               (u.overtimeTrackingLevel === parseInt(OvertimeTrackingLevel.READONLY) ||
                                u.overtimeTrackingLevel === parseInt(OvertimeTrackingLevel.TRUSTED))
                    }
                }

                return false
            }

            return !!accessRightsMap[AccessRights.SUBMIT_TIME_TRACK]
        })
    }

    _convertSharedSelectorUsers(users) {
        return users.map(u => {
            return {
                id: u.id,
                firstName: u.firstName,
                lastName: u.lastName,
                middleName: u.middleName,
                username: u.username,
                enabled: u.active,
                emailExists: u.emailExists,
                userGroupId: u.userGroupId,
                timeZoneGroupId: u.timeZoneGroupId
            }
        })
    }

    _mouseDown(event) {
        if (event.preventDefault)
            event.preventDefault()
        else // IE8
        {
            event.returnValue = false
            if (event.button && event.button && 4) // scroll is clicked
            {
                event.which = 2
                this.mouseUp(event)
            }
        }
        return false
    }

    _mouseUp(event) {
        if (!event.which && event.button) // IE8
        {
            if (event.button && 1) // left mouse button is clicked
                event.which = 1
            else
                return
        }

        if (event.which === 3)
            return

        const isScrollClicked = event.which === 2
        const target = getEventTarget(event)
        if (ReportConfigFactory.isActiveThisOrNone(this) && this._isGenerateReportArea(target) && this._isEnabled(target)) {
            const submitCSVForm = (generateCSVUrl, isScrollClicked) => {
                const form = $('#csvConfigForm')
                form.attr('action', generateCSVUrl)
                form.find('input[name=configId]').val(this.id)
                if (isScrollClicked)
                    form.attr('target', '_blank')
                else
                    form.attr('target', '_self')
                form.submit()
            }
            if (this.configFormat === 'CHART') {
                showChart(this.id)
            } else if (this.configFormat === 'CSV') {
                submitCSVForm(reportCSVPathFromDB[this.configType], isScrollClicked)
            } else {
                showReport(this.id, isScrollClicked)
            }
        }
    }

    _isGenerateReportArea(node) {
        hasParentWithClassName('configHeaderShareCell')
        return this._isConfigBody(node) &&
               !hasParentWithClassName(node, 'configHeaderRemoveCell') &&
               !hasParentWithClassName(node, 'configHeaderShareCell')
    }

    _isEnabled(node) {
        return hasParentWithClassName(node, 'enabled')
    }

    _isConfigBody(node) {
        return node != null && hasParentWithClassName(node, 'config') &&
               !hasParentWithClassName(node, 'space') &&
               !hasParentWithClassName(node, 'transparent-blank-cell')
    }

    _shareSavedConfig() {
        let users = this.shareButton.getSelectedUsers()
        const userIds = users.map(u =>  u.id)

        makeRpcCall(
            'SavedReportConfigsService.copyConfig',
            [this.id, userIds],
            function(successfullyCopiedUserIds) {
                if (successfullyCopiedUserIds.length === 1) {
                    const targetUser = users.find(() => successfullyCopiedUserIds[0])
                    const nameFormated = UserNameFormat.formatFL(targetUser)
                    toast(messageResource.getMessage('saved_reports.share.success_toast', [nameFormated]))
                } else {
                    toast(messageResource.getMessage(
                        'saved_reports.share.success_toast',
                        [
                            successfullyCopiedUserIds.length + ' ' + messageResource.getMessage('common.users')
                        ]
                    ))
                }
            },
            (jqXHR, textStatus, errorThrown) => {
                if (errorThrown.exception === 'com.actimind.actitime.reports.ReportConfigNotAvailableException') {
                    alert(messageResource.getMessage('saved_reports.common.config_not_available'))
                    document.location.reload()
                    return true
                }
            })

    }
}


// WEBPACK FOOTER //
// ./web/js/reports/ReportConfig.js